import { z } from 'zod'

// Schemas para validação de payloads reutilizados em alguns fluxos
export const userPropsSchema = z.object({
  email: z.string().email().optional(),
  name: z.string().optional(),
  uid: z.string().optional()
})

export const pageViewPropertiesSchema = z.object({
  $current_url: z.string().url()
})

// Constantes para as telas dos níveis
export const LEVEL_SCREENS = {
  INITIAL_SCREEN: 'initial',
  STEPS_SCREEN: 'steps',
  OUT_OF_TIME_SCREEN: 'out_of_time',
  OUT_OF_HEARTS_SCREEN: 'out_of_hearts',
  FINISH_SCREEN: 'finish'
} as const

// Tipos de eventos por módulo (atualizados com otimizações)
export const EVENT_TYPES = {
  JOURNEY: {
    VIEWED: 'journey_viewed',
    BLOCKED: 'journey_blocked'
  },
  LEVEL: {
    VIEWED: 'level_viewed',
    STARTED_OR_RESUMED: 'level_started_or_resumed', // Unificado
    OUT_OF_TIME: 'level_out_of_time',
    OUT_OF_HEARTS: 'level_out_of_hearts',
    COMPLETED: 'level_completed',
    BLOCKED: 'level_blocked'
    // Removido: LEAVE (apenas se botão explícito)
  },
  CHALLENGE: {
    STARTED: 'challenge_started', // Sampleado 40%
    COMPLETED: 'challenge_completed' // Sempre enviado
  },
  MISSION: {
    VIEWED: 'mission_viewed',
    STARTED: 'mission_started',
    COMPLETED: 'mission_completed',
    FAILED: 'mission_failed',
    REWARD_CLAIMED: 'mission_reward_claimed',
    LIST_INTERACTED: 'mission_list_interacted' // missions_filtered unificado
  },
  DOCUMENT: {
    VIEWED: 'document_viewed',
    DOWNLOADED: 'document_downloaded',
    SUBMITTED: 'document_submitted',
    SIGNED: 'document_signed',
    VERIFIED: 'document_verified'
  },
  // Novos eventos consolidados
  CONTENT: {
    SEARCHED: 'content_searched' // Unificado: help_searched + library_searched
  },
  USERS: {
    LIST_INTERACTED: 'users_list_interacted' // Unificado: users_list_filtered + users_feed_interaction
  }
} as const

// Tipo utilitário para eventos
export type AnalyticsEvent<T = Record<string, unknown>> = {
  name: string
  properties?: T
}

// Tipos específicos por módulo
export type LevelAnalyticsProps = {
  level: {
    id: string | number
    uid?: string
    name: string
    total_point_reward?: number
    coin_reward?: number
    total_coin_reward?: number
    _levelContinue?: boolean
    _finishedPercent?: number
    _correctPercent?: number
    stage_id?: string | number
  }
  currentScreen: string
  isBlocked?: boolean
}

export type JourneyAnalyticsProps = {
  journey?: {
    id: string | number
    uid?: string
    name: string
  }
}
